import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocsFeedbackFormComponent } from './common/components/docs-feedback-form/docs-feedback-form.component';
import { DocsSecondFeedbackFormComponent } from './common/components/docs-second-feedback-form/docs-second-feedback-form.component';
import { FeedbackFormComponent } from './common/components/feedback-form/feedback-form.component';
import { PublicComponent } from './common/components/public-page/public/public.component';
import { CommonAuthGuard } from './common/services/common-auth.guard';

const routes: Routes = [
  { path: 'cops', loadChildren: () => import('./modules/customer-care/customer-care.module').then(m => m.CustomerCareModule) },
  { path: 'en/public', component: PublicComponent },
  { path: 'en/online/feedback', component: FeedbackFormComponent },
  { path: 'en/docs/feedback', component: DocsFeedbackFormComponent },
  { path: 'en/documentation/feedback', component: DocsSecondFeedbackFormComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
  providers: [CommonAuthGuard]
})
export class AppRoutingModule { }
